import { useState } from "react";
import styles from "./Testimonials.module.scss";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import EditIcon from "@mui/icons-material/Edit";
import Button from "../../components/Button/Button";
import TitleWithLine from "../TitleWithLine/TitleWithLine";

function Testimonials({ testimonials, onOpenModal }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showFullTestimonial, setShowFullTestimonial] = useState(false);

  const validatedTestimonials = testimonials.filter(
    (testimonial) => testimonial.isValid,
  );

  const nextSlide = () => {
    if (validatedTestimonials.length > 0) {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % validatedTestimonials.length,
      );
    }
    setShowFullTestimonial(false);
  };

  const prevSlide = () => {
    if (validatedTestimonials.length > 0) {
      setCurrentIndex(
        (prevIndex) =>
          (prevIndex - 1 + validatedTestimonials.length) %
          validatedTestimonials.length,
      );
    }
    setShowFullTestimonial(false);
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " ...";
    }
    return text;
  };

  const isTextTruncated = (text, maxLength) => {
    return text.length > maxLength;
  };

  const getScreenWidth = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 900) {
      return 140;
    } else if (screenWidth <= 1024) {
      return 160;
    } else {
      return 180;
    }
  };

  const getTextMaxLength = () => {
    return getScreenWidth();
  };

  const hasTestimonials = validatedTestimonials.length > 0;

  return (
    <div className={styles.container}>
      <TitleWithLine text="Témoignages" color="var(--primary-color)" />

      {hasTestimonials ? (
        <>
          <div className={styles.display}>
            {validatedTestimonials.length > 1 && (
              <button
                className={`${styles.btn} ${styles.prevBtn}`}
                onClick={prevSlide}
              >
                <ArrowBackIosNewOutlinedIcon
                  fontSize="inherit"
                  color="inherit"
                />
              </button>
            )}

            <div className={styles.testimonial}>
              <p
                className={styles.text}
                onClick={() => setShowFullTestimonial(!showFullTestimonial)}
                style={{
                  cursor: isTextTruncated(
                    validatedTestimonials[currentIndex].testimonialText,
                    getTextMaxLength(),
                  )
                    ? "pointer"
                    : "auto",
                }}
              >
                {showFullTestimonial
                  ? validatedTestimonials[currentIndex].testimonialText
                  : truncateText(
                      validatedTestimonials[currentIndex].testimonialText,
                      getTextMaxLength(),
                    )}
              </p>
              <p className={styles.author}>
                {validatedTestimonials[currentIndex].firstName}
              </p>
            </div>

            {validatedTestimonials.length > 1 && (
              <button
                className={`${styles.btn} ${styles.nextBtn}`}
                onClick={nextSlide}
              >
                <ArrowForwardIosOutlinedIcon
                  fontSize="inherit"
                  color="inherit"
                />
              </button>
            )}
          </div>
        </>
      ) : (
        <div className={styles.empty}>
          <p className={styles.emptyText}>
            Soyez la première à laisser un avis et à partager votre expérience.
          </p>
        </div>
      )}

      <div className={styles.addBtn}>
        <Button
          color="var(--secondary-color)"
          onClick={onOpenModal}
          icon={EditIcon}
        >
          Ajouter un avis
        </Button>
      </div>
    </div>
  );
}

export default Testimonials;
